<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-produto-subgrupo') {
            next({ name: 'ven-produto-sub-grupo-list' });
        } else if (to.name == 'subgrupos') {
            next({ name: 'pro-produto-sub-grupo-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-produto-subgrupo') {
            this.$router.push({ name: 'ven-produto-sub-grupo-list' });
        }

        if (this.$route.name == 'subgrupos') {
            this.$router.push({ name: 'pro-produto-sub-grupo-list' });
        }
    },
};
</script>
